import React, { Fragment, useEffect, useRef, useState } from "react";
import { Row, Col, Card, Divider, Button, Input, Modal, Tabs, Select, Drawer, message, Checkbox, Form, Spin, Table } from "antd";
import {
  SearchOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  CloseOutlined,
  SyncOutlined,
  LoadingOutlined,
  EyeOutlined,
  UserOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { htmlPrint } from "../../../../lib/printer/htmlPrinter";
import Close from "../../../../assets/images/close-x.svg";
import User from "../../../../assets/images/User.svg";
import SearchIcon from "../../../../assets/images/searchIcon.svg";
import db from "../../../../database";
import { Scrollbars } from "react-custom-scrollbars";
import { useTranslation } from "react-i18next";
import userTieIcon from "../../../../assets/images/userTieIcon.svg";
import Keyboard from "react-simple-keyboard";
import _ from "lodash";
import "../styles.css";
import moment from "moment";
import wallet from "../../../../assets/images/wallet.svg";
import cash from "../../../../assets/images/cash.svg";
import credit from "../../../../assets/images/creditIcon.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import cardType from "../../../../assets/images/cardType.svg";
import UPI from "../../../../assets/images/upiIcon.svg";
import Credit from "../../../../assets/images/creditCardIcon.svg";
import ticSelect from "../../../../assets/images/tic.png";
import Loyality from "../../../../assets/images/loyalty.svg";
import Gift from "../../../../assets/images/giftIcon.svg";
import giftVoucher from "../../../../assets/images/giftVoucher.svg";
import creditNote from "../../../../assets/images/creditNote.svg";
import CWHCPrint from "../../../../lib/printer/CWHardwareController";
import CWPoleDisplay from "../../../../lib/printer/CWPoleDisplay";
import PoleDisplay from "../../../../lib/printer/poleDisplay";
import DeleteProduct from "../../../../assets/images/delete1.svg";
import { upsertWalletTransactionService } from "../../../../services";
import data from "../../../../constants/retailPos.json";
import messages from "../../../../errors/messages.en-IN.json";

const PointOfSuperMarketModals = (props) => {
  const {
    amount,
    cart,
    tillData,
    setCart,
    openSalesRep,
    setOpenSalesRep,
    selectedProductInCart,
    isStockModal,
    setIsStockModal,
    addProduct,
    handleCartTotalClick,
    tempCart,
    setTempCart,
    deleteCart,
    deleteProduct,
    posConfig,
    // open,
    // setOpen,
    keyboardType,
    setKeyboardType,
    // salesRepRef,
    salesRepValue,
    setSalesRepValue,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    selectedSaleTypeData,
    showPayments,
    setShowPayments,
    setShowPaymentMethods,
    setStartIndex,
    processOrder,
    upsertPOSLog,
    documentTypes,
    searchInputRef,
    showCustomerWallet,
    setShowCustomerWallet,
    customersData,
    setCustomersData,
    currenciesData,
    setCurrenciesData,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    handleCashPayment,
    showConfirm,
    handleAmount,
    requestPayment,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    setIsCardPaymentFlag,
    setOverPayedAmount,
    setAmount,
    paymentModalInputRef,
    filteredPaymentMethods,
    isShowingAll,
    showMoreItems,
    showPreviousItems,
    selectedCustomer,
    setSelectedCustomer,
    handleDeletePayment,
    setTillLink,
    tillLink,
    fetchWalletData,
    isWalletFlag,
    setIswalletFlag,
    realPrice,
    setRealPrice,
    PaymentMethods,
    getFilteredPaymentMethods,
  } = props;
  const { Option } = Select;
  const [cardPaymentForm] = Form.useForm();
  const [inputFocused, setInputFocused] = useState("");
  const authorizationRef = useRef(null);
  const [inputFields, setInputFields] = useState({});
  const [salesRepData, setSalesRepData] = useState([]);
  const [selectedSalesRep, setSelectedSalesRep] = useState({});
  const [itemWeights, setItemWeights] = useState(() => {
    const initialWeights = {};
    cart?.items.forEach((item) => {
      initialWeights[item.lineId] = item.availableQty;
    });
    return initialWeights;
  });
  const inputRefs = useRef([]);
  const salesRepRef = useRef(null);
  const keyboardRef = useRef(null);
  const topupInputRef = useRef(null);
  const cashInputRef = useRef(null);
  const cardInputRef = useRef(null);
  const upiInputRef = useRef(null);
  //const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const [open, setOpen] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [focusedInputField, setFocusedInputField] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [currentRecord, setCurrentRecord] = useState(null);
  const showVirtualKeyboard = posConfig?.showKeyboard === "Y" ? true : false;
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const [customerSearchValue, setCustomerSearchValue] = useState("");
  const [showTopupModal, setShowTopupModal] = useState(false);
  const [showTransactionsModal, setShowTransactionsModal] = useState(false);
  const [topupAmount, setTopupAmount] = useState("");
  //const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("Cash")
  const [isProcessingTopup, setIsProcessingTopup] = useState(false);
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y" ? true : false;
  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision;

  const [cashTendered, setCashTendered] = useState(0);
  const [currentCashInput, setCurrentCashInput] = useState("");
  const [showCardAmountInput, setShowCardAmountInput] = useState(false);
  const [currentCardInput, setCurrentCardInput] = useState("");
  const [currentUPIInput, setCurrentUPIInput] = useState("");
  const currenciesList = tillData?.tillAccess?.csBunit?.currencies;
  const [redeemAmount, setRedeemAmount] = useState(() => {
    return !isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00";
  });
  const [walletForm] = Form.useForm();
  useEffect(() => {
    // Only proceed if setCustomersData function is available
    if (typeof setCustomersData === "function") {
      if (!customersData) {
        // Initialize with cart customer if available
        if (cart?.customer) {
          const initialCustomer = {
            ...cart.customer,
            currentBalance: cart.customer.currentBalance || 0,
            totalSpent: cart.customer.totalSpent || 0,
            joinDate: cart.customer.joinDate || new Date().toISOString(),
            transactions: cart.customer.transactions || [],
          };
          setCustomersData([initialCustomer]);
        } else {
          setCustomersData([]);
        }
      } else if (!Array.isArray(customersData) && typeof customersData === "object") {
        // Normalize to array if customersData is a single object
        setCustomersData([customersData]);
      }
    }
  }, [cart?.customer]); // Only depend on cart?.customer
  // Hardcoded customer data
  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  // Payment methods
  const paymentMethods = [
    { value: "Cash", label: "Cash" },
    { value: "Credit Card", label: "Credit Card" },
    { value: "Debit Card", label: "Debit Card" },
    { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "UPI", label: "UPI" },
    { value: "Digital Wallet", label: "Digital Wallet" },
  ];

  useEffect(async () => {
    await db.salesRep.toArray((res) => {
      setSalesRepData(res);
    });
  }, []);

  useEffect(() => {
    if (openSalesRep?.flag && salesRepRef.current) {
      setTimeout(() => {
        salesRepRef.current.focus();
      }, 10);
    }
  }, [openSalesRep?.flag]);

  useEffect(() => {
    if (isStockModal) {
      const timeout = setTimeout(() => {
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [isStockModal]);

  useEffect(() => {
    const initialWeights = {};
    cart?.items.forEach((item) => {
      initialWeights[item.lineId] = item.weight <= item?.availableQty ? item.weight : item?.availableQty || 0; // Store as string to allow flexible input
    });
    setItemWeights(initialWeights);
  }, [cart]);

  const renderThumbHorizontalScroll = ({ style, ...props }) => {
    const thumbStyle = {
      width: "0px",
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const fetchSalesRepData = async (searchTerm) => {
    const results = await db.salesRep.filter((res) => res.name.toLowerCase().includes(searchTerm.toLowerCase()) || res.code.includes(searchTerm)).toArray();
    return results;
  };

  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSalesRepValue(value);

    const data = await fetchSalesRepData(value);
    setSalesRepData(data);
    if (!value) {
      setSalesRepData(data);
      return;
    }
  };

  useEffect(() => {
    const fetchSalesReps = async () => {
      if (openSalesRep?.flag) {
        try {
          const data = await fetchSalesRepData("");
          setSalesRepData(data);
          setSalesRepValue("");
        } catch (error) {
          console.error("Error fetching sales representatives:", error);
        }
      }
    };

    fetchSalesReps();
  }, [openSalesRep?.flag]);

  useEffect(() => {
    if (selectedPaymentMethod === "Card") {
      setShowCardAmountInput(false);
      cardPaymentForm.resetFields();
      setCurrentCardInput("");
      setCurrentUPIInput("");
    } else if (selectedPaymentMethod === "UPI") {
      setCurrentUPIInput("");
    }
  }, [selectedPaymentMethod]);

  useEffect(() => {
    if (showTopupModal) {
      setShowCardAmountInput(false);
      cardPaymentForm.resetFields();
      setCurrentCashInput("");
      setCurrentCardInput("");
      setCurrentUPIInput("");
      setCashTendered(0);
      // setSelectedPaymentMethod("Cash");
      setFocusedInputField("topupAmount");

      const cashPayments = showPayments?.filter((payment) => payment.methodName === "Cash");
      setSelectedPaymentMethod(cashPayments);
    }
  }, [showTopupModal, cardPaymentForm]);

  useEffect(() => {
    if (typeof setCart !== "function") {
      console.warn("setCart is not a function. Ensure it is passed as a prop from the parent component.");
      return;
    }
    if (!cart) {
      const initialCart = { payments: [], paid: 0, items: [], total: 0, customer: null };
      setCart(initialCart);
      localStorage.setItem("cartObj", JSON.stringify(initialCart));
    } else if (!cart.payments) {
      const updatedCart = { ...cart, payments: [], paid: cart.paid || 0 };
      setCart(updatedCart);
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
    }
  }, [cart, setCart]);

  const handleCardPayment = async (values) => {
    if (!topupAmount || Number.parseFloat(topupAmount) < 0) {
      message.error(`${messages.info.valid_topup_amount}`);
      return;
    }
    if (posConfig?.transactionID === "Y") {
      setShowCardAmountInput(true);
    }
  };
  useEffect(() => {
    if (isWalletFlag) {
      // When drawer opens, set redeemAmount to remaining due (amount)
      setRedeemAmount(!isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00");
    } else {
      // When drawer closes, reset redeemAmount
      setRedeemAmount("");
    }
  }, [isWalletFlag, amount]);
  const walletPopup = () => {
    const handleRedeemWallet = (value) => {
      if (value === "clear") {
        setRedeemAmount(""); // Clear the input
      } else if (value === "x") {
        setRedeemAmount((prev) => prev.slice(0, -1)); // Remove last character
      } else if (value === ".") {
        // Only allow one decimal point
        if (!redeemAmount.includes(".")) {
          setRedeemAmount((prev) => prev + value);
        }
      } else if (value === "00") {
        // Append "00" only if input is not empty or after a decimal
        if (redeemAmount !== "" || redeemAmount.includes(".")) {
          setRedeemAmount((prev) => prev + value);
        }
      } else {
        // Append number
        setRedeemAmount((prev) => prev + value);
      }
    };

    if (posConfig?.enable_customer_wallet !== "Y") return null;

    return (
      <Drawer
        centered
        closable={false}
        width="50%"
        headerStyle={{ background: "white", padding: "22px 10px", borderBottom: "none" }}
        height="75%"
        placement="bottom"
        bodyStyle={{ padding: "0% 7% 1% 7%", background: "#fff" }}
        footer={null}
        visible={isWalletFlag}
        onCancel={() => {
          setSelectedPaymentMethod({});
          setIswalletFlag(false);
          setRedeemAmount(""); // Reset redeemAmount on close
        }}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "2vh",
              fontSize: "1vw",
            }}
          >
            <p
              style={{
                fontSize: "1.5em",
                marginTop: "3vh",
                fontWeight: "500",
                color: "#0F0718",
                flex: 1,
                textAlign: "center",
              }}
            >
              Customer Wallet
            </p>
            <img
              src={Close}
              onClick={() => {
                setSelectedPaymentMethod({});
                setShowPayments(JSON.parse(localStorage.getItem("initialShowPayments")));
                setIswalletFlag(false);
                let PaymentMethods = getFilteredPaymentMethods() || [];
                const isPreOrderPage = window.location.pathname.includes("/preorder");
                if (isPreOrderPage) {
                  const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
                  const maxPaymentsToShow = isRefundScenario ? 3 : 3;
                  let payments =
                    PaymentMethods.length > maxPaymentsToShow
                      ? _.sortBy(PaymentMethods, "sequenceNo").slice(
                          0,
                          tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === maxPaymentsToShow
                            ? maxPaymentsToShow
                            : cart.layAway === "Y"
                            ? maxPaymentsToShow
                            : maxPaymentsToShow
                        )
                      : PaymentMethods;

                  setShowPayments(payments);
                  setStartIndex(cart.layAway === "Y" && payments.length >= maxPaymentsToShow ? maxPaymentsToShow : payments.length);
                }
                setRedeemAmount(""); // Reset redeemAmount on close
              }}
              style={{
                marginLeft: "auto",
                paddingBottom: "4vh",
                paddingTop: "2vh",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
        }
      >
        <Row gutter={[24, 24]} style={{ height: "100%" }}>
          {/* Left half - Cards and Additional Info */}
          <Col span={12}>
            {selectedCustomer && selectedCustomer[0] ? (
              <>
                <Row gutter={[16, 0]} style={{ marginBottom: "1rem" }}>
                  <Col span={8}>
                    <Card
                      style={{
                        borderRadius: "8px",
                        textAlign: "center",
                        border: "1px solid #e8e8e8",
                        height: "20vh",
                        backgroundColor: "#fff",
                      }}
                    >
                      <img src={credit || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "2vh", marginBottom: "2vh" }} alt="" />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Current Balance</h4>
                      <h2 style={{ margin: "0.5rem", color: "#28a745", fontSize: "1rem", fontWeight: "bold" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      style={{
                        borderRadius: "8px",
                        textAlign: "center",
                        border: "1px solid #e8e8e8",
                        height: "20vh",
                        backgroundColor: "#fff",
                      }}
                    >
                      <img src={cash || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "2vh", marginBottom: "2vh" }} alt="" />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Total Spent</h4>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.totalSpent?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </Card>
                  </Col>
                  <Col span={8}>
                    <Card
                      style={{
                        borderRadius: "8px",
                        textAlign: "center",
                        border: "1px solid #e8e8e8",
                        height: "20vh",
                        backgroundColor: "#fff",
                      }}
                    >
                      <CalendarOutlined
                        style={{
                          height: "3vh",
                          fontSize: "1.7em",
                          paddingRight: "5px",
                          marginTop: "2vh",
                          marginBottom: "2vh",
                        }}
                      />
                      <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Member Since</h4>
                      <h2 style={{ margin: "0.5rem 0", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                        {selectedCustomer[0]?.joinDate ? formatDate(selectedCustomer[0].joinDate) : ""}
                      </h2>
                    </Card>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: "1rem" }}>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Wallet Balance</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Bill Amount</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {!isNaN(cart.total) ? parseFloat(cart.total).toFixed(2) : cart.total.toFixed(2)}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={{ textAlign: "left", color: "#333" }}>
                      <p>
                        <strong>Remaining Due</strong>
                      </p>
                      <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem" }}>
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        {!isNaN(amount) ? parseFloat(amount).toFixed(2) : "0.00"}
                        {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                      </h2>
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <div style={{ textAlign: "center", padding: "1rem", color: "#666" }}>
                <h4>No customer selected</h4>
              </div>
            )}
          </Col>

          {/* Right half - Keypad */}
          <Col span={12}>
            <Col span={20} pull={2} push={2} style={{ padding: "" }}>
              <label>
                <span
                  style={{
                    color: "#0F0718",
                    fontSize: "1.25em",
                    fontWeight: "500",
                    marginBottom: "3vh",
                  }}
                >
                  Redeem Wallet Amount
                </span>
              </label>
              <Input
                id="amountNumber"
                value={redeemAmount} // Bind to redeemAmount
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only valid numeric input (including decimal point)
                  if (value === "" || /^(\d*\.?\d*)$/.test(value)) {
                    setRedeemAmount(value);
                  }
                }}
                onFocus={() => setInputFocused("amount")}
                size="large"
                onPressEnter={(e) => e.preventDefault()}
                allowClear={false}
                style={{
                  ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                  padding: "1.5vh 1vw",
                  fontSize: "1em",
                  marginBottom: "2vh",
                  border: "1px solid gray",
                }}
              />
            </Col>
            <Row style={{ padding: "0 8%" }} gutter={[8, 6]}>
              <Col span={6}>
                <button
                  id="sm-amount-button1"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("1");
                    e.preventDefault();
                  }}
                >
                  1
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button2"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("2");
                    e.preventDefault();
                  }}
                >
                  2
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button3"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("3");
                    e.preventDefault();
                  }}
                >
                  3
                </button>
              </Col>
              <Col span={6}>
                <button
                  className="amt-dial-btn-gift"
                  id="sm-amount-buttonRemove"
                  onClick={(e) => {
                    handleRedeemWallet("x");
                    e.preventDefault();
                  }}
                >
                  <img src={CancelArrow} alt="back space" width={25} height={15} />
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button4"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("4");
                    e.preventDefault();
                  }}
                >
                  4
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button5"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("5");
                    e.preventDefault();
                  }}
                >
                  5
                </button>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-button6"
                  className="amt-dial-btn-gift"
                  onClick={(e) => {
                    handleRedeemWallet("6");
                    e.preventDefault();
                  }}
                >
                  6
                </button>
              </Col>
              <Col span={6}>
                <button
                  onClick={(e) => {
                    handleRedeemWallet("clear");
                    e.preventDefault();
                  }}
                  id="sm-amount-addQuantity"
                  className="amt-dial-btn-gift"
                >
                  Clear
                </button>
              </Col>
              <Col span={18}>
                <Row gutter={[8, 6]}>
                  <Col span={8}>
                    <button
                      id="sm-amount-button7"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("7");
                        e.preventDefault();
                      }}
                    >
                      7
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button8"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("8");
                        e.preventDefault();
                      }}
                    >
                      8
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button9"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("9");
                        e.preventDefault();
                      }}
                    >
                      9
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button0"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("0");
                        e.preventDefault();
                      }}
                    >
                      0
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-buttonDot"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet(".");
                        e.preventDefault();
                      }}
                    >
                      .
                    </button>
                  </Col>
                  <Col span={8}>
                    <button
                      id="sm-amount-button00"
                      className="amt-dial-btn-gift"
                      onClick={(e) => {
                        handleRedeemWallet("00");
                        e.preventDefault();
                      }}
                    >
                      00
                    </button>
                  </Col>
                </Row>
              </Col>
              <Col span={6}>
                <button
                  id="sm-amount-buttonEnter"
                  className="amt-dial-btn-gift2"
                  onClick={(e) => {
                    e.preventDefault();
                    // Validation for the redeem amount
                    const amountValue = parseFloat(redeemAmount);
                    const walletBalance = parseFloat(selectedCustomer[0]?.currentBalance || 0);
                    const remainingDue = parseFloat(amount);

                    if (!redeemAmount || isNaN(amountValue) || amountValue <= 0) {
                      message.warning(`${messages.info.valid_amount}`);
                      return;
                    }
                    if (amountValue > walletBalance) {
                      message.warning(`${messages.warnings.payment.redeem_wallet_amount_exceeds}`);
                      return;
                    }
                    if (amountValue > remainingDue) {
                      message.warning(`${messages.warnings.payment.redeem_wallet_amount_exceeds_due}`);
                      return;
                    }
                    // Call requestPayment with wallet as payment method
                    requestPayment(selectedPaymentMethod, amountValue.toFixed(2));

                    // Reset the input and close the drawer
                    setRedeemAmount("");
                    setIswalletFlag(false);
                  }}
                >
                  Enter
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    );
  };

  const handleDenominationClick = (value) => {
    const sanitizedValue = Number.parseFloat(value.toString().replace(/[^0-9.]/g, "")) || 0;
    if (focusedInputField === "topupAmount") {
      const currentValue = Number.parseFloat(topupAmount) || 0;
      const newValue = (currentValue + sanitizedValue).toFixed(2);
      setTopupAmount(newValue);
    } else if (focusedInputField === "currentCashInput") {
      const currentValue = Number.parseFloat(currentCashInput) || 0;
      const newValue = (currentValue + sanitizedValue).toFixed(2);
      setCurrentCashInput(newValue);
    } else if (focusedInputField === "currentCardInput") {
      const currentValue = Number.parseFloat(currentCardInput) || 0;
      const newValue = (currentValue + sanitizedValue).toFixed(2);
      setCurrentCardInput(newValue);
    } else if (focusedInputField === "currentUPIInput") {
      const currentValue = Number.parseFloat(currentUPIInput) || 0;
      const newValue = (currentValue + sanitizedValue).toFixed(2);
      setCurrentUPIInput(newValue);
    }
    setDenaminationsKeyboard(true);
  };

  const handleCustomerSearch = (value) => {
    setCustomerSearchValue(value);
  };

  const filteredCustomers =
    Array.isArray(customersData) && customersData.length > 0
      ? customersData.filter(
          (customer) =>
            customer?.name?.toLowerCase().includes(customerSearchValue.toLowerCase()) ||
            customer?.phone?.includes(customerSearchValue) ||
            customer?.id?.toLowerCase().includes(customerSearchValue.toLowerCase())
        )
      : cart?.customer
      ? [cart.customer]
      : [];

  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
  };

  const handleChangeCustomer = () => {
    setSelectedCustomer(null);
    setCustomerSearchValue("");
    setShowTopupModal(false);
    setShowTransactionsModal(false);
  };

  const handleTopupWallet = () => {
    const initialPayments = _.sortBy(filteredPaymentMethods, "sequenceNo");
    setShowTopupModal(true);
    setShowTransactionsModal(false);
    setShowPayments(initialPayments);
    setDenaminationsKeyboard(true);
  };

  const handleViewTransactions = () => {
    setShowTransactionsModal(true);
    setShowTopupModal(false);
  };

  const handleTopupAmountChange = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, "");
    const parts = sanitizedValue.split(".");

    if (parts.length > 2) {
      return;
    }

    if (parts.length === 2 && parts[1].length > 2) {
      return;
    }

    setTopupAmount(sanitizedValue);
  };

  const rawWalletPayments = JSON.parse(localStorage.getItem("walletPayments")) || [];

  const matchedPayments = rawWalletPayments.map((payment) => {
    const matchedMethod = showPayments.find((method) => method.finPaymentmethodId === payment.finPaymentmethodID);

    return {
      ...matchedMethod,
      ...payment, // overwrite amount from matchedMethod with actual amount
      amount: Number(payment.amount).toFixed(2), // ensure string format like "400.00"
    };
  });

  const handleProcessTopup = async () => {
    if (!topupAmount || Number.parseFloat(topupAmount) <= 0) {
      message.error(`${messages.info.valid_amount}`);
      return;
    }

    setIsProcessingTopup(true);

    try {
      const amount = Number.parseFloat(topupAmount);
      const newTransaction = {
        id: (selectedCustomer?.transactions?.length || 0) + 1,
        date: new Date().toISOString().split("T")[0],
        time: new Date().toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        type: "Credit",
        amount: amount,
        description: `Wallet Top-up via ${selectedPaymentMethod.name}`,
        reference: `TXN${String(Date.now()).slice(-3)}`,
        balance: (selectedCustomer?.currentBalance || 0) + amount,
      };

      const updatedCustomer = {
        ...selectedCustomer,
        currentBalance: (selectedCustomer?.currentBalance || 0) + amount,
        lastTransaction: new Date().toISOString().split("T")[0],
        transactions: [newTransaction, ...(selectedCustomer?.transactions || [])],
      };

      // Only update customersData if setCustomersData function is available
      if (typeof setCustomersData === "function") {
        if (Array.isArray(customersData)) {
          const updatedCustomers = customersData.map((customer) => {
            if (customer?.id === selectedCustomer?.id) {
              return updatedCustomer;
            }
            return customer;
          });
          setCustomersData(updatedCustomers);
        } else {
          // If customersData is not an array, update it directly
          setCustomersData(updatedCustomer);
        }
      }

      setSelectedCustomer(updatedCustomer);

      message.success(
        `Wallet topped up successfully! Added ${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}${amount.toFixed(2)}${
          currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
        }`
      );

      setTimeout(() => {
        setIsProcessingTopup(false);
        setShowTopupModal(false);
        setTopupAmount("");
        setSelectedPaymentMethod("Cash");
      }, 1500);
    } catch (error) {
      console.error("Topup error:", error);
      message.error(`${messages.errors.payments.wallet_topup_failed}`);
      setIsProcessingTopup(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  useEffect(() => {
    if (showTopupModal) {
      const cashPayments = showPayments?.find((payment) => payment.name.toLowerCase() === "cash");
      setSelectedPaymentMethod(cashPayments);
      setDenaminationsKeyboard(true);
    }
  }, [showTopupModal, showPayments]);

  const handleWalletTopUp = async (amount) => {
    if (!cart?.customer?.cwrCustomerId || !cart?.customer?.b2cRegisteredstoreId) {
      message.error(`${messages.errors.customer.not_selected}`);
      return;
    }

    const paymentAmount = Number.parseFloat(amount || 0);
    const storedPayments = JSON.parse(localStorage.getItem("walletPayments"));

    if (!paymentAmount || isNaN(paymentAmount) || paymentAmount <= 0) {
      message.error(`${messages.info.invalid_topup}`);
      return;
    }

    const tillData = JSON.parse(localStorage.getItem("tillData"));

    const payload = {
      bunitId: tillData.tillAccess.csBunit.csBunitId,
      customerId: cart.customer.cwrCustomerId,
      trxType: "DP", // assuming DP = Deposit
      trxValue: paymentAmount,
      payments: storedPayments || [],
      transactionDetails: {
        paymnet: paymentAmount, // typo from original mutation, keep as-is unless it's fixed server-side
      },
    };

    try {
      const response = await upsertWalletTransactionService(payload);

      if (response?.status === "200") {
        message.success(response.message);
        fetchWalletData();
        setShowTopupModal(false);
        setTopupAmount("");
        setCurrentCashInput("");
        setCurrentCardInput("");
        setCurrentUPIInput("");
        setCashTendered(0);
        setShowCardAmountInput(false);
        cardPaymentForm.resetFields();
        localStorage.removeItem("walletPayments");
        localStorage.removeItem("cardPaymentDetails");
      } else {
        message.error(response?.message || `${messages.info.topup_failed}`);
      }
    } catch (err) {
      console.error("Failed to top up wallet:", err);
      message.error(`${messages.info.topup_record_failed}`);
    }
  };

  const handleTotalQty = (value) => {
    let currentValue =
      focusedInputField === "topupAmount"
        ? topupAmount
        : selectedPaymentMethod.name === "Cash"
        ? currentCashInput
        : selectedPaymentMethod.name === "Card"
        ? currentCardInput
        : currentUPIInput;

    if (value === "clear") {
      if (focusedInputField === "topupAmount") {
        setTopupAmount("");
      } else if (selectedPaymentMethod.name === "Cash") {
        setCurrentCashInput("");
      } else if (selectedPaymentMethod.name === "Card") {
        setCurrentCardInput("");
      } else {
        setCurrentUPIInput("");
      }
    } else if (value === "x") {
      if (focusedInputField === "topupAmount") {
        setTopupAmount(currentValue.slice(0, -1) || "");
      } else if (selectedPaymentMethod.name === "Cash") {
        setCurrentCashInput(currentValue.slice(0, -1) || "");
      } else if (selectedPaymentMethod.name === "Card") {
        setCurrentCardInput(currentValue.slice(0, -1) || "");
      } else {
        setCurrentUPIInput(currentValue.slice(0, -1) || "");
      }
    } else {
      const newValue = currentValue + value;
      const sanitizedValue = newValue.replace(/[^0-9.]/g, "");
      const parts = sanitizedValue.split(".");
      if (parts.length > 2 || (parts.length === 2 && parts[1].length > 2)) {
        return;
      }
      if (focusedInputField === "topupAmount") {
        setTopupAmount(sanitizedValue);
      } else if (selectedPaymentMethod.name === "Cash") {
        setCurrentCashInput(sanitizedValue);
      } else if (selectedPaymentMethod.name === "Card") {
        setCurrentCardInput(sanitizedValue);
      } else {
        setCurrentUPIInput(sanitizedValue);
      }
    }
  };

  const enterTotalQty = async () => {
    if (typeof setCart !== "function") {
      console.error("setCart is not a function. Cannot update cart.");
      message.error(`${messages.errors.payments.configuration_payment_failed}`);
      return;
    }

    const currentInput = selectedPaymentMethod.name === "Cash" ? currentCashInput : selectedPaymentMethod.name === "Card" ? currentCardInput : currentUPIInput;

    if (!currentInput || Number.parseFloat(currentInput) <= 0) {
      message.error(`${messages.info.valid_amount}`);
      return;
    }

    if (!topupAmount || Number.parseFloat(topupAmount) <= 0) {
      message.error(`${messages.info.valid_topup_amount}`);
      return;
    }

    const paymentAmount = Number.parseFloat(currentInput).toFixed(2);
    const topupTotal = Number.parseFloat(topupAmount).toFixed(2);
    const newCashTendered = (Number.parseFloat(cashTendered) || 0) + Number.parseFloat(paymentAmount);

    // Calculate total payments from matchedPayments
    const totalPayments = matchedPayments.reduce((sum, payment) => sum + Number.parseFloat(payment.amount || 0), 0).toFixed(2);

    // Check if the new payment amount exceeds the top-up amount
    if (Number.parseFloat(totalPayments) + Number.parseFloat(paymentAmount) > topupTotal) {
      message.error(`${selectedPaymentMethod.name} ${messages.warnings.payment.payment_multiple_check_topup} ${topupTotal - totalPayments}`);
      return;
    }

    setIsProcessingTopup(true);

    try {
      // Validate denomination for cash payments
      if (selectedPaymentMethod.name === "Cash") {
        const filteredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
        if (filteredCurrencies.length > 0) {
          const result = modulo(Number.parseFloat(currentInput || 0), filteredCurrencies[0]?.value || 1);
          if (result !== 0) {
            message.warning(`${messages.warnings.payment.payment_multiple_check} ${filteredCurrencies[0]?.value}`);
            setIsProcessingTopup(false);
            return;
          }
        }
      }

      // Call requestPayment with the payment method object
      await requestPayment(selectedPaymentMethod, paymentAmount, undefined, true);

      // Persist cart to localStorage
      localStorage.setItem("cartObj", JSON.stringify(cart));

      // Recalculate total payments after adding the new payment
      const updatedTotalPayments = (Number.parseFloat(totalPayments) + Number.parseFloat(paymentAmount)).toFixed(2);

      // Create new transaction
      const newTransaction = {
        id: (selectedCustomer?.transactions?.length || 0) + 1,
        date: new Date().toISOString().split("T")[0],
        time: new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true }),
        type: "Credit",
        amount: Number.parseFloat(paymentAmount),
        description: `Wallet Top-up via ${selectedPaymentMethod.name}`,
        reference: `TXN${String(Date.now()).slice(-3)}`,
        balance: (selectedCustomer?.currentBalance || 0) + Number.parseFloat(paymentAmount),
      };

      // Update customer data
      const updatedCustomer = {
        ...selectedCustomer,
        currentBalance: (selectedCustomer?.currentBalance || 0) + Number.parseFloat(paymentAmount),
        lastTransaction: new Date().toISOString().split("T")[0],
        transactions: [newTransaction, ...(selectedCustomer?.transactions || [])],
      };

      if (typeof setCustomersData === "function") {
        if (Array.isArray(customersData)) {
          const updatedCustomers = customersData.map((customer) => (customer?.id === selectedCustomer?.id ? updatedCustomer : customer));
          setCustomersData(updatedCustomers);
        } else {
          setCustomersData(updatedCustomer);
        }
      }

      setSelectedCustomer(updatedCustomer);
      setCurrentCashInput("");
      setCurrentCardInput("");
      setCurrentUPIInput("");
      setCashTendered(newCashTendered);

      // Check if total payments equal topupAmount
      if (Number.parseFloat(updatedTotalPayments) >= Number.parseFloat(topupTotal)) {
        await handleWalletTopUp(topupAmount);
      } else {
        message.success(
          `${selectedPaymentMethod.name} payment of ${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}${paymentAmount}${
            currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
          } added. Remaining: ${currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}${(topupTotal - updatedTotalPayments).toFixed(2)}${
            currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""
          }`
        );
        setIsProcessingTopup(false);
      }
    } catch (error) {
      console.error(`${selectedPaymentMethod.name} top-up error:`, error);
      message.error(`${selectedPaymentMethod?.name || "Payment"} ${messages.errors.payments.wallet_topup_failed}`);
      setIsProcessingTopup(false);
    }
  };

  const handleCancelTopup = () => {
    setShowTopupModal(false);
    setTopupAmount("");
    setCurrentCashInput("");
    setCurrentCardInput("");
    setCurrentUPIInput("");
    setCashTendered(0);
    //setSelectedPaymentMethod("Cash")
    setShowCardAmountInput(false);
    cardPaymentForm.resetFields();
    localStorage.removeItem("walletPayments");
    setDenaminationsKeyboard(true);
  };

  const handleShift = () => {
    setLayoutName(layoutName === "shift" ? "default" : "shift");
  };

  const handleKeyboardInputs = (button) => {
    const currentValue = cardPaymentForm.getFieldValue(inputFocused) || "";
    if (button === "{space}") {
      cardPaymentForm.setFieldsValue({
        [inputFocused]: `${currentValue} `,
      });
    } else if (button === "{backspace}") {
      cardPaymentForm.setFieldsValue({
        [inputFocused]: currentValue.slice(0, -1),
      });
    } else {
      cardPaymentForm.setFieldsValue({
        [inputFocused]: currentValue + button,
      });
    }
  };

  const handleQtyChange = (value, recordIndex, productId, isDecimal) => {
    let sanitizedValue = value.replace(/[^0-9.]/g, "");
    if (!isDecimal) {
      sanitizedValue = sanitizedValue.replaceAll(".", "");
    }

    // Handle multiple dots if decimal is allowed
    if (isDecimal) {
      const parts = sanitizedValue.split(".");
      if (parts.length > 2) {
        // Keep only the first dot and merge the rest
        sanitizedValue = parts[0] + "." + parts.slice(1).join("");
      }

      // Restrict precision to 3 digits after the decimal
      if (parts.length === 2 && parts[1].length > 3) {
        sanitizedValue = parts[0] + "." + parts[1].substring(0, 3);
      }
    }

    // Handle leading zeros for non-decimal values
    let displayValue = sanitizedValue;
    if (sanitizedValue.startsWith("0") && sanitizedValue.length > 1 && !sanitizedValue.includes(".")) {
      displayValue = sanitizedValue.substring(1);
    }

    // Allow raw decimal input without immediate formatting
    displayValue = displayValue === "" ? "0" : displayValue;

    const updatedTempCart = { ...tempCart };
    let tempData = { ...itemWeights };
    tempData[productId] = displayValue;
    setItemWeights(tempData);

    const parsedWeight = parseFloat(displayValue);
    if (!isNaN(parsedWeight)) {
      updatedTempCart[productId] = parsedWeight;
      setTempCart(updatedTempCart);
    }
  };

  const handleKeyDown = (e, isDecimal, index) => {
    let totalItems = (parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
      (item) => item.weight !== 0
    );
    if (!isDecimal && e.key === ".") {
      e.preventDefault();
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (index < totalItems.length - 1) {
        // Move to the next input
        inputRefs.current[index + 1]?.focus();
      } else {
        // If it's the last input, perform confirm action
        handleSubmit();
        setIsStockModal(false);
      }
    }
  };

  const handleKeyboardInput = (key) => {
    // Handle layout changes
    if (key === "{shift}") {
      setLayoutName(layoutName === "shift" ? "default" : "shift");
      return;
    }
    if (key === "{number}") {
      setLayoutName("number");
      return;
    }
    if (key === "{numbers}") {
      setLayoutName("numbers");
      return;
    }
    if (key === "{small}") {
      setLayoutName("shift");
      return;
    }
    if (key === "{caps}") {
      setLayoutName("default");
      return;
    }

    if (focusedInput !== null && currentRecord) {
      let currentValue = itemWeights[focusedInput] || "";
      currentValue = currentValue.toString();

      if (key === "{bksp}") {
        currentValue = currentValue.slice(0, -1);
        if (currentValue === "") {
          currentValue = "0";
        }
      } else if (key === "{enter}") {
        setOpen(false);
      } else if (key === ".") {
        if (currentRecord.isDecimal && !currentValue.includes(".")) {
          currentValue += ".";
        } else if (!currentRecord.isDecimal) {
          currentValue = currentValue.replace(".", "");
        }
      } else if (!/^\d*\.?\d*$/.test(currentValue + key)) {
        return; // Prevent invalid characters
      } else {
        if (currentValue === "0") {
          currentValue = key;
        } else {
          currentValue += key;
        }

        // Precision restriction for decimals
        if (currentRecord.isDecimal) {
          const parts = currentValue.split(".");
          if (parts.length === 2 && parts[1].length > 3) {
            currentValue = parts[0] + "." + parts[1].substring(0, 3);
          }
        }
      }

      // Update item weights and cart
      const updatedItemWeights = { ...itemWeights };
      updatedItemWeights[focusedInput] = currentValue;
      setItemWeights(updatedItemWeights);

      const updatedTempCart = { ...tempCart };
      updatedTempCart[focusedInput] = parseFloat(currentValue) || 0;
      setTempCart(updatedTempCart);
    }
  };

  const handleSubmit = async () => {
    let showPaymentsFlag = false;
    let deleteItems = [];
    await Promise.all(
      tempCart.items.map((item) => {
        if (itemWeights[item.lineId] > 0) {
          showPaymentsFlag = true;
          if (item.weight !== itemWeights[item.lineId]) {
            item.modified = true;
            return addProduct(item, itemWeights[item.lineId], true);
          }
        } else {
          deleteItems.push(item);
        }
      })
    );
    if (tempCart.items.length !== deleteItems.length) {
      await Promise.all(
        deleteItems.map((item) => {
          deleteProduct(item);
        })
      );
    } else {
      deleteCart();
    }
    if (showPaymentsFlag) {
      handleCartTotalClick();
    }
  };

  const handleDocumentClick = (type) => {
    if (type === "Invoice") {
      setShowDocumentPopup(false);
      setSelectedDocumentType("Invoice");
      cart.layAway = "N";
      setCart(cart);
      localStorage.setItem("cartObj", JSON.stringify(cart));
    } else if (type === "Advance") {
      if (selectedSaleTypeData?.cwrSaletype?.enableLayaway === "Y") {
        const requireCustomer = posConfig?.requireCustomerforLayaway === "Y" ? tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== cart.customer.cwrCustomerId : true;
        if (requireCustomer) {
          if (cart.items.length > 0 || posConfig?.enableItemRestrictionForAdvance !== "Y") {
            if (!cart.isReturn) {
              if (cart.paid === 0) {
                if (posConfig?.advanceLayaway === "Y") {
                  setShowDocumentPopup(false);
                  upsertPOSLog(cart, "LAY");
                  cart.layAway = "Y";
                  setCart(cart);
                  localStorage.setItem("cartObj", JSON.stringify(cart));
                  const payments =
                    showPayments.length >= 5
                      ? _.sortBy(showPayments, "sequenceNo").slice(
                          0,
                          tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === cart.customer.cwrCustomerId && showPayments.length === 6 ? 4 : 4
                        )
                      : showPayments;
                  setSelectedDocumentType("Advance");
                  setStartIndex(payments.length);
                  setShowPayments(payments);
                  setShowPaymentMethods(true);
                } else {
                  setShowDocumentPopup(false);
                  upsertPOSLog(cart, "LAY");
                  processOrder("layaway");
                }
              }
            } else {
              message.error(`${messages.warnings.cart.advance_not_supported}`);
            }
          } else {
            message.error(`${messages.warnings.cart.before_advance_check}`);
          }
        } else {
          message.warning(`${messages.errors.customer.select_for_proceed}`);
        }
      } else {
        message.error(`${messages.info.advance_not_enabled}`);
      }
    } else if (type === "Quotation") {
      if (posConfig?.enableQuotation === "Y") {
        setShowDocumentPopup(false);
        setSelectedDocumentType("Quotation");
        cart.isQuotation = true;
        setCart(cart);
        localStorage.setItem("cartObj", JSON.stringify(cart));
      }
    }
  };

  return (
    <Fragment>
      {/* sales rep modal start */}
      <Drawer
        closable={true}
        placement="bottom"
        title={
          <div style={{ display: "flex", alignItems: "center", height: "2vh", fontSize: "1vw" }}>
            <p style={{ fontSize: "1.5em", marginTop: "3vh", fontWeight: "500", color: "#0F0718", flex: 1, textAlign: "center" }}>Select a Sales Representative</p>
            <img
              src={Close}
              onClick={() => {
                setSelectedSalesRep({});
                setOpenSalesRep({ flag: false, level: "" });
                setOpen(false);
                setLayoutName("default");
                setSalesRepValue("");
                if (searchInputRef?.current) {
                  searchInputRef?.current.focus();
                }
              }}
              style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
            />
          </div>
        }
        closeIcon={null}
        visible={openSalesRep?.flag}
        className="filter"
        bodyStyle={{ paddingBottom: 0, paddingTop: 0 }}
        onClose={() => {
          setSelectedSalesRep({});
          setOpenSalesRep({ flag: false, level: "" });
          setOpen(false);
        }}
        height="90vh"
      >
        <Row style={{ paddingLeft: "0.7vw", fontSize: "1vw", paddingBottom: "2vh" }}>
          <Col span={9}>
            <Input
              type="text"
              ref={salesRepRef}
              value={salesRepValue}
              className="productSearch"
              placeholder={`Search`}
              // id="giftCardSearchInput"
              id="sm-product-search"
              onChange={handleSearchChange}
              onFocus={() => {
                setKeyboardType({
                  searchCus: false,
                  parkedBill: false,
                  salesHistory: false,
                  salesHistoryCus: false,
                  product: false,
                  giftCardSearch: false,
                  salesRep: true,
                  addCustomer: false,
                });
                setTimeout(() => {
                  keyboardRef?.current?.setInput(salesRepValue);
                  setOpen(true);
                }, 300);
              }}
              onPressEnter={(e) => e.preventDefault()}
              style={{
                width: "35vw",
                padding: "5px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "1vw",
                color: "#0F0718",
                borderColor: "rgba(0, 0, 0, 0.25)",
              }}
              prefix={
                <img
                  src={SearchIcon}
                  alt=""
                  style={{
                    width: "15px",
                    height: "15px",
                    paddingLeft: "0.2vw",
                  }}
                />
              }
            />
          </Col>
        </Row>
        <Scrollbars style={{ height: "55vh", width: "100%" }} renderThumbHorizontal={renderThumbHorizontalScroll}>
          <Row gutter={[16, 16]}>
            {salesRepData?.map((res) => (
              <Col
                span={6}
                style={{
                  background: selectedSalesRep.code === res.code ? "#cae5bd" : "#fff",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  margin: "0 1rem",
                  padding: "0rem 0.5rem",
                }}
                // onClick={() => {
                //   setSelectedSalesRep(res);
                // }}
                onClick={() => {
                  let cartObj = cart;
                  if (openSalesRep.level === "order") {
                    cartObj.salesRepId = res.s_salesrep_id;
                    cartObj.salesRepName = res.name;
                    setCart(cartObj);
                    localStorage.setItem("cartObj", JSON.stringify(cartObj));
                    setSelectedSalesRep({});
                    setOpenSalesRep({ flag: false, level: "" });
                  } else if (openSalesRep.level === "line") {
                    cartObj?.items?.map((lineItem) => {
                      if (lineItem.productId === selectedProductInCart.productId && lineItem.lineId === selectedProductInCart.lineId) {
                        lineItem.salesRepId = res.s_salesrep_id;
                        lineItem.salesRepName = res.name;
                      }
                    });
                    setCart(cartObj);
                    localStorage.setItem("cartObj", JSON.stringify(cartObj));
                    setSelectedSalesRep({});
                    setOpenSalesRep({ flag: false, level: "" });
                  }
                }}
              >
                <img src={User} alt="" style={{ marginRight: "10px", height: "2.5rem", margin: "0.7rem 0 " }} />
                <span style={{ marginLeft: "10px", margin: "0.7rem 0px 0.7rem 10px", fontSize: "1vw" }}>
                  <p style={{ margin: 0, fontWeight: 500, fontSize: "1em", color: "#0F0718" }}>{res.name}</p>
                  <span style={{ fontSize: "0.8em", fontWeight: 500, color: "#0F0718" }}>{res.code}</span>
                </span>
              </Col>
            ))}
          </Row>
        </Scrollbars>
        <Row>
          <Col span={24} style={{ textAlign: "right", paddingTop: "1rem" }}>
            <Button
              style={{ backgroundColor: "#0F0718", color: "#fff", height: "7vh", width: "15vw", borderRadius: "7px" }}
              disabled={!selectedSalesRep?.code}
              onClick={() => {
                let cartObj = cart;
                if (openSalesRep.level === "order") {
                  cartObj.salesRepId = selectedSalesRep.s_salesrep_id;
                  cartObj.salesRepName = selectedSalesRep.name;

                  setCart(cartObj);
                  localStorage.setItem("cartObj", JSON.stringify(cartObj));
                  setSelectedSalesRep({});
                  setOpenSalesRep({ flag: false, level: "" });
                } else if (openSalesRep.level === "line") {
                  cartObj?.items?.map((lineItem) => {
                    if (lineItem.productId === selectedProductInCart.productId && lineItem.lineId === selectedProductInCart.lineId) {
                      lineItem.salesRepId = selectedSalesRep.s_salesrep_id;
                      lineItem.salesRepName = selectedSalesRep.name;
                    }
                  });
                  setCart(cartObj);
                  localStorage.setItem("cartObj", JSON.stringify(cartObj));
                  setSelectedSalesRep({});
                  setOpenSalesRep({ flag: false, level: "" });
                }
              }}
            >
              Continue
            </Button>
          </Col>
        </Row>
      </Drawer>
      {/* sales rep modal end */}

      {/* Stock Confirmation Start */}
      <Drawer
        closable={true}
        placement="bottom"
        title={
          <div style={{ display: "flex", alignItems: "center", height: "2vh", fontSize: "1vw" }}>
            <p style={{ fontSize: "1.5em", marginTop: "3vh", fontWeight: "500", color: "#0F0718", flex: 1, textAlign: "center" }}>Stock Confirmation</p>
            <img
              src={Close}
              onClick={() => {
                setIsStockModal(false);
                setOpen(false);
                setLayoutName("default");
              }}
              style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
            />
          </div>
        }
        closeIcon={null}
        visible={isStockModal}
        className="filter"
        bodyStyle={{ padding: "0 4vw" }}
        onClose={() => {
          setIsStockModal(false);
          setOpen(false);
          setLayoutName("default");
        }}
        height="90vh"
      >
        <Table
          className="sm-cart-table-pos-stock"
          style={{
            width: "100%",
            overflowY: "auto",
            border: "none",
            borderRadius: "7px",
            padding: "0px 7px",
            height: "67vh",
            background: themeJSON.productTableBGColor || "#fff",
          }}
          pagination={false}
          dataSource={(parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
            (item) => item.availableQty < item.weight
          )}
          sticky
          id="sm-cart-table"
          columns={[
            {
              title: "Item Name",
              dataIndex: "name",
              key: "name",
              width: "32%",
              render: (text, record, index) => {
                return (
                  <>
                    <div onClick={() => {}} id="sm-product-name" className="tableRow">
                      {record.name}
                    </div>
                    <div className="offerName">
                      {record.availableQty >= record.weight ? (
                        <p style={{ margin: 0, color: "#009000" }}>Available</p>
                      ) : record.availableQty > 0 && record.weight > 0 ? (
                        <p style={{ margin: 0, color: "#FF5E0E" }}>Only {record.availableQty} Available</p>
                      ) : (
                        <p style={{ margin: 0, color: "red" }}>Out Of Stock</p>
                      )}
                    </div>
                  </>
                );
              },
            },
            {
              title: "UOM",
              dataIndex: "uom_name",
              key: "uom_name",
              width: "12%",
              render: (text, record, index) => {
                return <div style={{ textAlign: "left" }}>{text}</div>;
              },
              align: "center",
            },
            {
              title: "Order Qty",
              dataIndex: "weight",
              key: "weight",
              width: "15%",
              align: "right",
              render: (text, record) => {
                return <div style={{ textAlign: "right" }}>{parseFloat(text).toFixed(2)}</div>;
              },
            },
            {
              title: "Available Qty",
              dataIndex: "availableQty",
              key: "availableQty",
              width: "15%",
              align: "right",
              render: (text, record) => {
                return (
                  <div style={{ textAlign: "right", color: text > 0 ? "#0F0718" : "red" }}>
                    {text?.toFixed(2).length < 8 ? parseFloat(text)?.toFixed(2) : `${text?.toString().substring(0, 8)}`}
                  </div>
                );
              },
            },
            {
              title: "Update Order Qty",
              dataIndex: "availableQty",
              key: "availableQty",
              width: "22%",
              align: "center",
              paddingLeft: "3vw",
              textAlign: "right",
              render: (text, record, index) => {
                return (
                  <Input
                    key={record.lineId}
                    style={{ width: "10vw", textAlign: "right" }}
                    ref={(el) => (inputRefs.current[index] = el)}
                    value={itemWeights[record.lineId]}
                    onChange={(e) => handleQtyChange(e.target.value, index, record.lineId, record.isDecimal)}
                    onPressEnter={(e) => e.preventDefault()}
                    onKeyDown={(e) => handleKeyDown(e, record.isDecimal, index)}
                    onFocus={() => {
                      setFocusedInput(record.lineId);
                      setOpen(true);
                      setCurrentRecord(record);
                    }}
                  />
                );
              },
            },
          ]}
        />
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            style={{
              backgroundColor: "#fff",
              color: "#2F3856",
              height: "7vh",
              width: "15vw",
              borderRadius: "7px",
              marginTop: "1rem",
            }}
            onClick={() => {
              setIsStockModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "#2F3856",
              color: "#fff",
              height: "7vh",
              width: "15vw",
              borderRadius: "7px",
              marginTop: "1rem",
              marginLeft: "1rem",
            }}
            onClick={() => {
              handleSubmit();
              setIsStockModal(false);
            }}
          >
            Confirm
          </Button>
        </div>
      </Drawer>
      {/* Stock Confirmation End */}

      {open && showVirtualKeyboard && (
        <Drawer placement="bottom" closable={false} bodyStyle={{ paddingBottom: 0 }} height="47vh" visible={open && showVirtualKeyboard} mask={false}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
            <img
              src={Close}
              onClick={() => {
                setOpen(false);
              }}
              style={{
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
          <div style={{ padding: "0 4vw 0" }}>
            <Keyboard
              keyboardRef={(r) => {
                keyboardRef.current = r;
                // if (keyboardType.salesRep) {
                //   salesRepRef.current = r;
                // }
              }}
              onChange={(val) => {
                if (keyboardType.salesRep) {
                  setSalesRepValue(val);
                  handleSearchChange({ target: { value: val } });
                  if (salesRepRef && salesRepRef.current) {
                    setTimeout(() => {
                      salesRepRef.current.focus();
                    }, 10);
                  }
                }
              }}
              layoutName={layoutName}
              display={{
                "{bksp}": "⌫",
                "{numbers}": "123",
                "{shift}": "⇧",
                "{enter}": "Enter",
                "{space}": "Space",
                "{number}": "123",
                "{caps}": "ABC",
                "{small}": "abc",
              }}
              layout={{
                shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} @ {space} . {enter}"],
                numbers: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{caps} {space} {enter}"],
                number: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{small} {space} {enter}"],
                default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} @ {space} . {enter}"],
              }}
              onKeyPress={handleKeyboardInput}
            />
          </div>
        </Drawer>
      )}

      {/* Document Type select Popup start*/}
      <Modal
        visible={showDocumentPopup}
        closable={true}
        onCancel={() => {
          setShowDocumentPopup(false);
        }}
        keyboard={false}
        footer={null}
        width="33%"
        centered
        bodyStyle={{ padding: 10, backgroundColor: "#F3F4F9" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "4vh 2.5vw" }}>
          {documentTypes
            ?.filter((doc) => doc.type !== selectedDocumentType)
            ?.map((doc) => {
              return (
                doc.isVisible && (
                  <Button
                    key={doc.type}
                    style={{
                      height: "9vh",
                      borderRadius: "5px",
                      cursor: doc.isEnabled ? "pointer" : "not-allowed",
                      backgroundColor: "#2F3856",
                      color: "#fff",
                      fontSize: "1.1rem",
                      border: "1px solid #2F3856",
                      textAlign: "center",
                      fontWeight: 400,
                    }}
                    onClick={() => doc.isEnabled && handleDocumentClick(doc.type)}
                  >
                    {doc.type}
                  </Button>
                )
              );
            })}
        </div>
      </Modal>
      {/* Document Type select Popup end*/}

      {/* Customer Wallet Modal Start */}
      <Drawer
        className="customerWalletDrawer"
        visible={showCustomerWallet}
        closable={false}
        onClose={() => {
          setShowCustomerWallet(false);
          setSelectedCustomer(null);
          setCustomerSearchValue("");
          setShowTopupModal(false);
          setShowTransactionsModal(false);
          setTopupAmount("");
          //setSelectedPaymentMethod("Cash")
        }}
        placement="right"
        width="62%"
        headerStyle={{ background: "white", borderBottom: "none" }}
        bodyStyle={{ padding: "0.5rem", paddingTop: 0, background: "white" }}
        style={{ borderRadius: "15px" }}
        title={
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ fontSize: "1.3rem", fontWeight: "550", color: "#0F0718", paddingTop: "13px" }}>
              <img src={wallet || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", paddingLeft: "7px" }} alt="" />
              {showTopupModal ? "Top-up Wallet" : showTransactionsModal ? `Transaction History - ${selectedCustomer[0]?.name || "Customer"}` : "Customer Wallet Management"}
            </div>
            <img
              src={Close || "/placeholder.svg"}
              onClick={() => {
                if (showTopupModal || showTransactionsModal) {
                  setShowTopupModal(false);
                  setShowTransactionsModal(false);
                  setTopupAmount("");
                  setCurrentCashInput("");
                  setCurrentCardInput("");
                  setCurrentUPIInput("");
                  setCashTendered(0);
                  setShowCardAmountInput(false);
                  cardPaymentForm.resetFields();
                  localStorage.removeItem("walletPayments");
                } else {
                  setShowCustomerWallet(false);
                  setSelectedCustomer(null);
                  setCustomerSearchValue("");
                  setShowTopupModal(false);
                  setShowTransactionsModal(false);
                  setTopupAmount("");
                  setCurrentCashInput("");
                  setCurrentCardInput("");
                  setCurrentUPIInput("");
                  setCashTendered(0);
                  setShowCardAmountInput(false);
                  cardPaymentForm.resetFields();
                  localStorage.removeItem("walletPayments");
                }
              }}
              style={{ cursor: "pointer", width: "1.5vw" }}
              alt="Close"
            />
          </div>
        }
      >
        {showTopupModal ? (
          // Top-up Modal Section
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            <div
              style={{
                height: "3em",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                verticalAlign: "center",
                fontSize: "1rem",
                backgroundColor: "#f0f0f0",
                color: "#28a745",
                fontWeight: "bold",
                marginTop: "0.5rem",
                //marginBottom: "1rem",
                borderRadius: "12px",
              }}
            >
              Current Balance: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
              {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
              {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            </div>
            <Card
              style={{
                borderRadius: "8px",
                border: "none",
                background: "transparent",
              }}
            >
              <Form layout="vertical" onFinish={handleCardPayment} form={cardPaymentForm}>
                <Row gutter={[10, 10]}>
                  <Col span={24}>
                    <div>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "0.3rem",
                          color: "#0F0718",
                          fontWeight: "600",
                          fontSize: "1rem",
                        }}
                      >
                        Top-up Amount
                      </label>
                      <Input
                        ref={topupInputRef}
                        size="large"
                        value={topupAmount}
                        onChange={(e) => handleTopupAmountChange(e.target.value)}
                        onFocus={() => setFocusedInputField("topupAmount")}
                        placeholder="0"
                        style={{
                          textAlign: "right",
                          fontSize: "1rem",
                          borderRadius: "6px",
                        }}
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <Scrollbars style={{ height: "6vh" }}>
                      {matchedPayments?.length > 0 ? (
                        matchedPayments.map((item, index) => (
                          <Row key={index} style={{ fontSize: "1vw" }}>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "0.8vw",
                                fontWeight: "450",
                                textAlign: "left",
                              }}
                            >
                              <p style={{ margin: "0" }}>{item.name}</p>
                            </Col>
                            <Col
                              span={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingRight: "1vw",
                                textAlign: "right",
                                justifyContent: "end",
                              }}
                            >
                              <p
                                style={{
                                  textAlign: "right",
                                  margin: "0",
                                  fontWeight: "500",
                                  paddingRight: "1.2vw",
                                }}
                              >
                                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)}
                                {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                              </p>
                            </Col>
                          </Row>
                        ))
                      ) : (
                        <Row style={{ fontSize: "1vw", textAlign: "center" }}>
                          <Col span={24}>
                            <p style={{ margin: "0", color: "#888" }}>No payments added</p>
                          </Col>
                        </Row>
                      )}
                    </Scrollbars>
                  </Col>
                  <Col span={24}>
                    <div>
                      <label
                        style={{
                          display: "block",
                          color: "#0F0718",
                          fontWeight: "600",
                          fontSize: "1rem",
                        }}
                      >
                        Payment Method
                      </label>
                      <div style={{ display: "flex", gap: 5 }}>
                        {_.sortBy(
                          showPayments?.filter((pm) => ["cash", "card", "upi"].includes(pm.name.toLowerCase())),
                          ["sequenceNo", "name"]
                        ).map((pm) => (
                          <Button
                            key={pm.name}
                            type={selectedPaymentMethod?.name === pm.name ? "primary" : "default"}
                            onClick={() => {
                              setCurrentCashInput("");
                              setCurrentCardInput("");
                              setCurrentUPIInput("");
                              setCashTendered(0);
                              cardPaymentForm.resetFields();
                              setDenaminationsKeyboard(pm.name.toLowerCase() === "cash");
                              setFocusedInputField(null);
                              setSelectedPaymentMethod(pm);
                              setShowCardAmountInput(pm.name.toLowerCase() === "card" && posConfig?.transactionID === "Y" ? false : true);
                              setTimeout(() => {
                                if (pm.name.toLowerCase() === "cash") {
                                  cashInputRef.current?.focus();
                                  setFocusedInputField("currentCashInput");
                                } else if (pm.name.toLowerCase() === "card" && (posConfig?.transactionID !== "Y" || showCardAmountInput)) {
                                  cardInputRef.current?.focus();
                                  setFocusedInputField("currentCardInput");
                                } else if (pm.name.toLowerCase() === "upi") {
                                  upiInputRef.current?.focus();
                                  setFocusedInputField("currentUPIInput");
                                }
                              }, 0);
                            }}
                            style={{
                              flex: 1,
                              height: "40px",
                              fontSize: "0.9rem",
                              backgroundColor: selectedPaymentMethod?.name === pm.name ? "#2F3856" : themeJSON.paymentMethodsBGColor || "#fff",
                              color: selectedPaymentMethod?.name === pm.name ? "#fff" : "#0F0718",
                              borderColor: themeJSON.paymentMethodsBGColor || "#e8e8e8",
                              borderRadius: "7px",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <span>
                                {pm.name.toLowerCase() === "cash" ? (
                                  <>
                                    {currenciesList[0]?.currSymbol || ""} {pm.name}
                                  </>
                                ) : pm.name.toLowerCase() === "card" ? (
                                  <>
                                    <img src={cardType} style={{ height: "15px", marginRight: "5px" }} alt="card" />
                                    {pm.name}
                                  </>
                                ) : pm.name.toLowerCase() === "upi" ? (
                                  <>
                                    <img src={UPI} style={{ height: "15px", marginRight: "5px" }} alt="upi" />
                                    {pm.name}
                                  </>
                                ) : (
                                  <>{pm.name}</>
                                )}
                              </span>
                            </div>
                          </Button>
                        ))}
                      </div>
                    </div>
                  </Col>
                  {/* Rest of the top-up modal content */}
                  {selectedPaymentMethod?.name === "Cash" && denaminationsKeyboard ? (
                    // Cash denomination keyboard
                    <Col span={24}>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "600",
                            fontSize: "1rem",
                          }}
                        >
                          Enter Amount
                        </label>
                        <div>
                          <Row>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "6vh",
                                margin: "0 0% 2.7% 0%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                                border: "1px solid #f0f0f0",
                              }}
                              value={currentCashInput}
                              id="sm-amount-input"
                              onChange={(e) => setCurrentCashInput(e.target.value?.replace(/[^\d.]/g, ""))}
                              onFocus={() => setFocusedInputField("currentCashInput")}
                              ref={cashInputRef}
                              placeholder="0"
                            />
                          </Row>
                          <Row style={{ padding: "0 0% 0 0.5%" }}>
                            <Col span={18}>
                              <Row gutter={[8, 5]} style={{ display: "flex", flexDirection: "row-reverse" }}>
                                {currenciesData.map((currency) => (
                                  <Col span={8} key={currency.value}>
                                    <button
                                      id={`sm-amount-button${currenciesData.indexOf(currency) + 1}`}
                                      className="amt-dial-btn-market"
                                      onClick={() => handleDenominationClick(currency.value)}
                                      disabled={currency.value === 999999}
                                      style={{
                                        color: currency.value !== 999999 ? "#0f0718" : "transparent",
                                        background: themeJSON?.keyBoardColor,
                                      }}
                                    >
                                      {currency.value}
                                    </button>
                                  </Col>
                                ))}
                              </Row>
                            </Col>
                            <Col span={6}>
                              <Row style={{ padding: "0 0 2% 4%" }}>
                                <button
                                  className="amt-dial-btn-market"
                                  id="sm-amount-buttonRemove"
                                  onClick={() => handleTotalQty("x")}
                                  style={{ background: themeJSON?.keyBoardColor }}
                                >
                                  <img src={CancelArrow} alt="back space" width={25} height={15} />
                                </button>
                              </Row>
                              <Row style={{ padding: "0 0 2% 4%" }}>
                                <button
                                  id="sm-amount-buttonClear"
                                  className="amt-dial-btn-market"
                                  onClick={() => {
                                    handleTotalQty("clear");
                                    setDenaminationsKeyboard(false);
                                    setLayoutName("numbers");
                                  }}
                                  style={{ background: themeJSON?.keyBoardColor }}
                                >
                                  1,2,3...
                                </button>
                              </Row>
                              <Row style={{ padding: "0 0 0 4%" }}>
                                <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty} style={{ background: themeJSON?.keyBoardColor }}>
                                  Enter
                                </button>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  ) : selectedPaymentMethod?.name === "Cash" && !denaminationsKeyboard ? (
                    // Numeric keyboard for cash
                    <Col span={24}>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "600",
                            fontSize: "1rem",
                          }}
                        >
                          Enter Amount
                        </label>
                        <div>
                          <Row>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "6vh",
                                margin: "0 0% 2.7% 0%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                                border: "1px solid #f0f0f0",
                              }}
                              value={currentCashInput}
                              id="sm-amount-input"
                              onChange={(e) => setCurrentCashInput(e.target.value?.replace(/[^\d.]/g, ""))}
                              onFocus={() => setFocusedInputField("currentCashInput")}
                              ref={cashInputRef}
                              placeholder="0"
                            />
                          </Row>
                          <Row style={{ padding: "0 0% 0 0.5%" }} gutter={[8, 6]}>
                            <Col span={6}>
                              <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("1")}>
                                1
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("2")}>
                                2
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("3")}>
                                3
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                className="amt-dial-btn-market"
                                id="sm-amount-buttonRemove"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => handleTotalQty("x")}
                              >
                                <img src={CancelArrow} alt="back space" width={25} height={15} />
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("4")}>
                                4
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("5")}>
                                5
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("6")}>
                                6
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                id="sm-amount-buttonClear"
                                className="amt-dial-btn-market"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => {
                                  setDenaminationsKeyboard(true);
                                  setLayoutName("numbers");
                                }}
                              >
                                1,2,3...
                              </button>
                            </Col>
                            <Col span={18}>
                              <Row gutter={[8, 6]}>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button7"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("7")}
                                  >
                                    7
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button8"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("8")}
                                  >
                                    8
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button9"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("9")}
                                  >
                                    9
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button0"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("0")}
                                  >
                                    0
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button00"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty(".")}
                                  >
                                    .
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button-clear"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("clear")}
                                  >
                                    Clear
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" style={{ background: themeJSON?.keyBoardColor }} onClick={enterTotalQty}>
                                Enter
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  ) : selectedPaymentMethod?.name === "Card" && posConfig?.transactionID === "Y" && !showCardAmountInput ? (
                    // Card payment details
                    <Row>
                      <Col span={10} style={{ paddingRight: "1vw" }}>
                        <Row>
                          <Col span={20}>
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              name="transactionId"
                              rules={[
                                {
                                  required: posConfig?.transactionID_mandatory === "Yes",
                                  message: `Please enter Transaction ID`,
                                },
                              ]}
                              label={
                                <span
                                  style={{
                                    color: "#000",
                                    fontSize: "1rem",
                                    fontWeight: "500",
                                  }}
                                >
                                  Transaction ID
                                </span>
                              }
                            >
                              <Input
                                id="transactionId"
                                placeholder={`Transaction ID`}
                                onFocus={() => {
                                  setInputFocused("transactionId");
                                  setLayoutName("default");
                                }}
                                size="large"
                                onPressEnter={(e) => e.preventDefault()}
                                allowClear={false}
                                style={{
                                  borderRadius: "6px",
                                  padding: "8px 12px",
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={20}>
                            {posConfig?.authorizationCode === "Y" && (
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                name="authorization"
                                rules={[
                                  {
                                    required: posConfig?.authorizationCode_mandatory === "Yes",
                                    message: `Please enter Authorization Code`,
                                  },
                                ]}
                                label={
                                  <span
                                    style={{
                                      color: "#000",
                                      fontSize: "1rem",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Authorization Code
                                  </span>
                                }
                              >
                                <Input
                                  id="pin"
                                  ref={authorizationRef}
                                  placeholder={`Authorization Code`}
                                  size="large"
                                  onPressEnter={(e) => e.preventDefault()}
                                  onFocus={() => {
                                    setInputFocused("authorization");
                                    setLayoutName("default");
                                  }}
                                  allowClear={false}
                                  style={{
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                  }}
                                />
                              </Form.Item>
                            )}
                          </Col>
                          <Col span={20}>
                            {posConfig?.cardType === "Y" && (
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                name="cardType"
                                rules={[
                                  {
                                    required: posConfig?.cardType_mandatory === "Yes",
                                    message: `Please select Card Type`,
                                  },
                                ]}
                                label={
                                  <span
                                    style={{
                                      color: "#000",
                                      fontSize: "1rem",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Card Type
                                  </span>
                                }
                              >
                                <Select className="selecItem" placeholder={<span className="cartSelect">Card Type</span>} size="large" style={{ borderRadius: "6px" }}>
                                  <Option className="cartOption" key="VI" value="VI">
                                    Visa - VI
                                  </Option>
                                  <Option className="cartOption" key="MA" value="MA">
                                    Master Card - MA
                                  </Option>
                                  <Option className="cartOption" key="RU" value="RU">
                                    Rupay - RU
                                  </Option>
                                  <Option className="cartOption" key="AM" value="AM">
                                    Amex - AM
                                  </Option>
                                  <Option className="cartOption" key="ME" value="ME">
                                    Maestro - ME
                                  </Option>
                                </Select>
                              </Form.Item>
                            )}
                          </Col>
                          <Col span={20}>
                            {posConfig?.CardNumber === "Y" && (
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                name="cardNumber"
                                rules={[
                                  {
                                    required: posConfig?.CardNumber_mandatory === "Yes",
                                    message: `Please enter Card Number`,
                                  },
                                  {
                                    pattern: /^\d{4}$/,
                                    message: `Card Number must be exactly 4 digits`,
                                  },
                                ]}
                                label={
                                  <span
                                    style={{
                                      color: "#000",
                                      fontSize: "1rem",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Card Number (Last 4 Digits)
                                  </span>
                                }
                              >
                                <Input
                                  id="redeemNumber"
                                  placeholder={`Enter Number`}
                                  onFocus={() => {
                                    setInputFocused("cardNumber");
                                    setLayoutName("numbers");
                                  }}
                                  size="large"
                                  onPressEnter={(e) => e.preventDefault()}
                                  allowClear={false}
                                  style={{
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                  }}
                                  maxLength={4}
                                />
                              </Form.Item>
                            )}
                          </Col>
                        </Row>
                      </Col>
                      <Col span={14} style={{ padding: "" }}>
                        <Row gutter={[8, 6]}>
                          <Keyboard
                            theme={"hg-theme-default aprvl"}
                            style={{ marginTop: "5px" }}
                            onChangeAll={(inputs) => {
                              setInputFields({ ...inputs });
                              cardPaymentForm.setFieldsValue(inputs);
                            }}
                            inputName={inputFocused}
                            keyboardRef={(r) => (keyboardRef.current = r)}
                            onKeyPress={(button) => {
                              const currentValue = cardPaymentForm.getFieldValue(inputFocused) || "";
                              if (inputFocused === "cardNumber") {
                                if (button.match(/^\d$/)) {
                                  if (currentValue.length < 4) {
                                    cardPaymentForm.setFieldsValue({
                                      cardNumber: currentValue + button,
                                    });
                                  }
                                  return;
                                } else if (button === "{backspace}") {
                                  cardPaymentForm.setFieldsValue({
                                    [inputFocused]: currentValue.slice(0, -1),
                                  });
                                }
                                return;
                              }
                              if (button === "{shift}" || button === "{lock}") {
                                handleShift();
                              } else if (button === "{number}" || button === "{numbers}") {
                                setLayoutName("numbers");
                              } else if (button === "{small}") {
                                setLayoutName("shift");
                              } else if (button === "{caps}") {
                                setLayoutName("default");
                              } else if (button === "{space}") {
                                cardPaymentForm.setFieldsValue({
                                  [inputFocused]: `${currentValue} `,
                                });
                              } else if (button === "{backspace}") {
                                cardPaymentForm.setFieldsValue({
                                  [inputFocused]: currentValue.slice(0, -1),
                                });
                              } else if (button !== "{enter}" && button !== "{shift}" && button !== "{caps}" && button !== "{numbers}") {
                                handleKeyboardInputs(button);
                              }
                            }}
                            layoutName={layoutName}
                            display={{
                              "{abc}": "ABC",
                              "{smileys}": "\uD83D\uDE03",
                              "{back}": "Enter",
                              "{numbers}": "123",
                              "{number}": "123",
                              "{bksp}": "backspace",
                              "{backspace}": "⌫",
                              "{shift}": "⇧",
                              "{tab}": "tab",
                              "{lock}": "lock",
                              "{enter}": "Enter",
                              "{space}": "Space",
                              "{caps}": "ABC",
                              "{small}": "abc",
                            }}
                            layout={{
                              shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                              numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                              number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                              default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
                            }}
                          />
                          <Col span={20} pull={2} push={2} style={{ padding: "3% 0", marginTop: "1%" }}>
                            <Button
                              htmlType="button"
                              onClick={() => {
                                const cardValues = cardPaymentForm.getFieldsValue();
                                localStorage.setItem("cardPaymentDetails", JSON.stringify(cardValues));
                                cardPaymentForm
                                  .validateFields()
                                  .then(() => {
                                    setShowCardAmountInput(true);
                                  })
                                  .catch(() => {
                                    message.error(`${messages.info.all_required}`);
                                  });
                              }}
                              style={{
                                backgroundColor: "#2F3856",
                                color: "#fff",
                                width: "100%",
                                fontSize: "1rem",
                                textAlign: "center",
                                fontWeight: "400",
                                borderRadius: "7px",
                                height: "40px",
                              }}
                            >
                              Submit
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : selectedPaymentMethod?.name === "Card" && (posConfig?.transactionID !== "Y" || showCardAmountInput) ? (
                    // Card amount input
                    <Col span={24}>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "600",
                            fontSize: "1rem",
                          }}
                        >
                          Enter Amount
                        </label>
                        <div>
                          <Row>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "6vh",
                                margin: "0 0% 2.7% 0%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                                border: "1px solid #f0f0f0",
                              }}
                              value={currentCardInput}
                              id="sm-amount-input"
                              onChange={(e) => setCurrentCardInput(e.target.value?.replace(/[^\d.]/g, ""))}
                              onFocus={() => setFocusedInputField("currentCardInput")}
                              ref={cardInputRef}
                              placeholder="0"
                            />
                          </Row>
                          <Row style={{ padding: "0 0% 0 0.5%" }} gutter={[4, 3]}>
                            <Col span={6}>
                              <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("1")}>
                                1
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("2")}>
                                2
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("3")}>
                                3
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                className="amt-dial-btn-market"
                                id="sm-amount-buttonRemove"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => handleTotalQty("x")}
                              >
                                <img src={CancelArrow} alt="back space" width={25} height={15} />
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("4")}>
                                4
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("5")}>
                                5
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("6")}>
                                6
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                id="sm-amount-buttonClear"
                                className="amt-dial-btn-market"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => {
                                  setDenaminationsKeyboard(true);
                                  setLayoutName("numbers");
                                }}
                              >
                                1,2,3...
                              </button>
                            </Col>
                            <Col span={18}>
                              <Row gutter={[4, 3]}>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button7"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("7")}
                                  >
                                    7
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button8"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("8")}
                                  >
                                    8
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button9"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("9")}
                                  >
                                    9
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button0"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("0")}
                                  >
                                    0
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button00"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty(".")}
                                  >
                                    .
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button-clear"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("clear")}
                                  >
                                    Clear
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" style={{ background: themeJSON?.keyBoardColor }} onClick={enterTotalQty}>
                                Enter
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  ) : selectedPaymentMethod?.name === "UPI" ? (
                    // UPI amount input
                    <Col span={24}>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "0.3rem",
                            color: "#0F0718",
                            fontWeight: "600",
                            fontSize: "1rem",
                          }}
                        >
                          Enter Amount
                        </label>
                        <div>
                          <Row>
                            <Input
                              className="productSearch sm-payment-search totalQtyInput"
                              style={{
                                borderRadius: "0.5vw",
                                height: "6vh",
                                margin: "0 0% 2.7% 0%",
                                borderRadius: "5px",
                                textAlign: "right",
                                fontWeight: "500",
                                fontSize: "2.5em",
                                borderColor: "#fff",
                                color: "#2F3856",
                                fontFamily: "Inter",
                                border: "1px solid #f0f0f0",
                              }}
                              value={currentUPIInput}
                              id="sm-amount-input"
                              onChange={(e) => setCurrentUPIInput(e.target.value?.replace(/[^\d.]/g, ""))}
                              onFocus={() => setFocusedInputField("currentUPIInput")}
                              ref={upiInputRef}
                              placeholder="0"
                            />
                          </Row>
                          <Row style={{ padding: "0 0% 0 0.5%" }} gutter={[4, 3]}>
                            <Col span={6}>
                              <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("1")}>
                                1
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("2")}>
                                2
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("3")}>
                                3
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                className="amt-dial-btn-market"
                                id="sm-amount-buttonRemove"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => handleTotalQty("x")}
                              >
                                <img src={CancelArrow} alt="back space" width={25} height={15} />
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("4")}>
                                4
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("5")}>
                                5
                              </button>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleTotalQty("6")}>
                                6
                              </button>
                            </Col>
                            <Col span={6}>
                              <button
                                id="sm-amount-buttonClear"
                                className="amt-dial-btn-market"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => {
                                  setDenaminationsKeyboard(true);
                                  setLayoutName("numbers");
                                }}
                              >
                                1,2,3...
                              </button>
                            </Col>
                            <Col span={18}>
                              <Row gutter={[8, 6]}>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button7"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("7")}
                                  >
                                    7
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button8"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("8")}
                                  >
                                    8
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button9"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("9")}
                                  >
                                    9
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button0"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("0")}
                                  >
                                    0
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button00"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty(".")}
                                  >
                                    .
                                  </button>
                                </Col>
                                <Col span={8}>
                                  <button
                                    id="sm-amount-button-clear"
                                    className="amt-dial-btn-market"
                                    style={{ background: themeJSON?.keyBoardColor }}
                                    onClick={() => handleTotalQty("clear")}
                                  >
                                    Clear
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={6}>
                              <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" style={{ background: themeJSON?.keyBoardColor }} onClick={enterTotalQty}>
                                Enter
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                  ) : null}
                </Row>
              </Form>
            </Card>
          </div>
        ) : showTransactionsModal ? (
          // Transaction History Section
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                border: "1px solid #e8e8e8",
                maxHeight: "87vh",
                overflowY: "auto",
                //padding: "1rem",
              }}
            >
              {selectedCustomer[0]?.transactions && selectedCustomer[0].transactions.length > 0 ? (
                selectedCustomer[0].transactions
                  .sort((a, b) => {
                    const dateTimeA = new Date(`${a.date} ${a.time}`);
                    const dateTimeB = new Date(`${b.date} ${b.time}`);
                    return dateTimeB - dateTimeA;
                  })
                  .map((transaction, index) => (
                    <div
                      key={transaction.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0.5rem",
                        borderBottom: index < selectedCustomer[0].transactions.length - 1 ? "1px solid #f0f0f0" : "none",
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                          <span
                            style={{
                              padding: "0.3rem 1rem",
                              borderRadius: "20px",
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              backgroundColor: transaction.type === "Credit" ? "#d4edda" : "#f8d7da",
                              color: transaction.type === "Credit" ? "#155724" : "#721c24",
                              marginRight: "0.5rem",
                            }}
                          >
                            {transaction.type}
                          </span>
                          <span style={{ color: "#666", fontSize: "0.8rem" }}>
                            {transaction.date} at {transaction.time}
                          </span>
                        </div>
                        <h4 style={{ margin: "0.3rem 0", color: "#0F0718", fontSize: "1rem" }}>{transaction.description}</h4>
                        <p style={{ margin: 0, color: "#666", fontSize: "0.6rem" }}>Ref: {transaction.reference}</p>
                      </div>
                      <div style={{ textAlign: "right", minWidth: "150px" }}>
                        <h3
                          style={{
                            margin: 0,
                            fontSize: "1rem",
                            fontWeight: "bold",
                            color: transaction.type === "Credit" ? "#28a745" : "#dc3545",
                          }}
                        >
                          {transaction.type === "Credit" ? "+" : "-"}
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                          {transaction.amount.toFixed(2)}
                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                        </h3>
                        <p style={{ margin: "0.3rem 0 0 0", color: "#666", fontSize: "0.8rem" }}>
                          Balance: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                          {transaction.balance.toFixed(2)}
                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                        </p>
                      </div>
                    </div>
                  ))
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "3rem",
                    color: "#666",
                  }}
                >
                  <h3>No transactions found</h3>
                  <p>This customer hasn't made any transactions yet.</p>
                </div>
              )}
            </div>
          </div>
        ) : selectedCustomer ? (
          // Customer Details Section
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
                padding: "0.7rem",
                backgroundColor: "#fff",
                borderRadius: "10px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", height: "3vh", marginRight: "1rem" }}>
                <UserOutlined
                  style={{
                    fontSize: "1.5rem",
                    color: "#2F3856",
                    marginRight: "0.5rem",
                    padding: "0.5rem",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "50%",
                  }}
                />
                <div>
                  <h2 style={{ margin: 0, color: "#0F0718", fontSize: "1rem" }}>{selectedCustomer[0]?.name}</h2>
                  <p style={{ margin: "0.2rem 0", color: "#666", fontSize: "0.7rem" }}>
                    {selectedCustomer[0]?.phone && selectedCustomer[0]?.phone !== "N/A" ? `Mobile: ${selectedCustomer[0]?.phone} | ` : ""}ID: {selectedCustomer[0]?.id}
                  </p>
                </div>
              </div>
            </div>
            <Row gutter={[24, 24]} style={{ marginBottom: "0.5rem" }}>
              <Col span={8}>
                <Card
                  style={{
                    borderRadius: "10px",
                    textAlign: "center",
                    border: "1px solid #e8e8e8",
                    height: "20vh",
                    backgroundColor: "#fff",
                  }}
                >
                  <img src={credit || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "3vh", marginBottom: "3vh" }} alt="" />
                  <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Current Balance</h4>
                  <h2 style={{ margin: "0.5rem", color: "#28a745", fontSize: "1rem", fontWeight: "bold" }}>
                    {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {selectedCustomer[0]?.currentBalance?.toFixed(2) || "0.00"}
                    {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                  </h2>
                </Card>
              </Col>
              <Col span={8}>
                <Card
                  style={{
                    borderRadius: "10px",
                    textAlign: "center",
                    border: "1px solid #e8e8e8",
                    height: "20vh",
                    backgroundColor: "#fff",
                  }}
                >
                  <img src={cash || "/placeholder.svg"} style={{ height: "3vh", paddingRight: "5px", marginTop: "3vh", marginBottom: "3vh" }} alt="" />
                  <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Total Spent</h4>
                  <h2 style={{ margin: "0.5rem", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                    {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {selectedCustomer[0]?.totalSpent?.toFixed(2) || "0.00"}
                    {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                  </h2>
                </Card>
              </Col>
              <Col span={8}>
                <Card
                  style={{
                    borderRadius: "10px",
                    textAlign: "center",
                    border: "1px solid #e8e8e8",
                    height: "20vh",
                    backgroundColor: "#fff",
                  }}
                >
                  <CalendarOutlined
                    style={{
                      height: "3vh",
                      fontSize: "1.7em",
                      paddingRight: "5px",
                      marginTop: "3vh",
                      marginBottom: "3vh",
                    }}
                  />
                  <h4 style={{ margin: 0, color: "#666", fontSize: "1rem" }}>Member Since</h4>
                  <h2 style={{ margin: "0.5rem 0", color: "#0F0718", fontSize: "1rem", fontWeight: "bold" }}>
                    {selectedCustomer?.[0]?.joinDate ? formatDate(selectedCustomer[0].joinDate) : ""}
                  </h2>
                </Card>
              </Col>
            </Row>
            <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
              <Button
                type="primary"
                size="large"
                onClick={() => {
                  handleTopupWallet();
                  setTimeout(() => {
                    topupInputRef.current?.focus();
                  }, 0);
                }}
                style={{
                  backgroundColor: "#2F3856",
                  borderColor: "#2F3856",
                  height: "45px",
                  width: "25em",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  borderRadius: "6px",
                  paddingLeft: "2rem",
                  paddingRight: "2rem",
                }}
              >
                Top-up Wallet
              </Button>
              <Button
                size="large"
                onClick={handleViewTransactions}
                icon={<EyeOutlined />}
                style={{
                  color: "#0F0718",
                  height: "45px",
                  width: "25em",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  borderRadius: "6px",
                  paddingLeft: "2rem",
                  paddingRight: "2rem",
                }}
              >
                View Transactions
              </Button>
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <h3 style={{ color: "#0F0718", fontSize: "1.2rem", fontWeight: "600" }}>Recent Transactions</h3>
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  border: "1px solid #e8e8e8",
                  height: "38vh",
                  overflowY: "auto",
                  //padding: "1rem",
                }}
              >
                {selectedCustomer?.[0]?.transactions?.length > 0 && currenciesList?.[0] ? (
                  selectedCustomer[0].transactions
                    .sort((a, b) => {
                      const dateTimeA = new Date(`${a.date} ${a.time}`);
                      const dateTimeB = new Date(`${b.date} ${b.time}`);
                      return dateTimeB - dateTimeA;
                    })
                    .slice(0, 22)
                    .map((transaction, index) => {
                      const currency = currenciesList[0];
                      return (
                        <div
                          key={transaction.id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0.5rem",
                            borderBottom: index < 21 ? "1px solid #f0f0f0" : "none",
                            backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                              <span
                                style={{
                                  borderRadius: "20px",
                                  fontSize: "0.8rem",
                                  fontWeight: "600",
                                  backgroundColor: transaction.type === "Credit" ? "#d4edda" : "#f8d7da",
                                  color: transaction.type === "Credit" ? "#155724" : "#721c24",
                                  marginRight: "0.5rem",
                                  padding: "0.2rem 0.6rem",
                                }}
                              >
                                {transaction.type}
                              </span>
                              <span style={{ color: "#666", fontSize: "0.8rem" }}>
                                {transaction.date} at {transaction.time}
                              </span>
                            </div>
                            <h4 style={{ margin: "0.3rem 0", color: "#0F0718", fontSize: "1rem" }}>{transaction.description}</h4>
                            <p style={{ margin: 0, color: "#666", fontSize: "0.6rem" }}>Ref: {transaction.reference}</p>
                          </div>
                          <div style={{ textAlign: "right", minWidth: "120px" }}>
                            <h3
                              style={{
                                margin: 0,
                                fontSize: "1rem",
                                fontWeight: "bold",
                                color: transaction.type === "Credit" ? "#28a745" : "#dc3545",
                              }}
                            >
                              {transaction.type === "Credit" ? "+" : "-"}
                              {currency.symbolRightSide === "N" ? currency.currSymbol : ""}
                              {transaction.amount.toFixed(2)}
                              {currency.symbolRightSide === "Y" ? currency.currSymbol : ""}
                            </h3>
                            <p style={{ margin: "0.3rem 0 0 0", color: "#666", fontSize: "0.8rem" }}>
                              Bal: {currency.symbolRightSide === "N" ? currency.currSymbol : ""}
                              {transaction.balance.toFixed(2)}
                              {currency.symbolRightSide === "Y" ? currency.currSymbol : ""}
                            </p>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div style={{ textAlign: "center", padding: "1rem", color: "#666" }}>
                    <h4>No recent transactions</h4>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          // Customer Search Section
          <div style={{ marginLeft: "1.5em", marginRight: "1.5em" }}>
            <Input
              placeholder="Search Customer by Name, Mobile, or ID"
              value={customerSearchValue}
              onChange={(e) => handleCustomerSearch(e.target.value)}
              prefix={<SearchOutlined />}
              style={{
                marginBottom: "1rem",
                height: "40px",
                borderRadius: "6px",
              }}
            />
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                border: "1px solid #e8e8e8",
                maxHeight: "70vh",
                overflowY: "auto",
                padding: "1rem",
              }}
            >
              {filteredCustomers.length > 0 ? (
                filteredCustomers.map((customer) => (
                  <div
                    key={customer.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "1rem",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                    }}
                    onClick={() => handleCustomerSelect(customer)}
                  >
                    <div>
                      <h4 style={{ margin: 0, color: "#0F0718", fontSize: "1rem" }}>{customer.name}</h4>
                      <p style={{ margin: "0.2rem 0", color: "#666", fontSize: "0.8rem" }}>
                        Mobile: {customer.phone} | ID: {customer.id}
                      </p>
                    </div>
                    <span style={{ color: "#28a745", fontSize: "0.9rem" }}>
                      {/* Balance: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""} */}
                    </span>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center", padding: "3rem", color: "#666" }}>
                  <h3>No customers found</h3>
                  <p>Try searching with a different keyword.</p>
                </div>
              )}
            </div>
          </div>
        )}
      </Drawer>
      {walletPopup()}
      {/* Customer Wallet Drawer End */}
    </Fragment>
  );
};

export default PointOfSuperMarketModals;
